import { Literal, Record, String, Union } from "runtypes";

const TagType = Union(Literal("auto"), Literal("manual"));

export const TagsResponse = Record({
  value: String,
  type: TagType,
});
